import {useTransform, useSpring, MotionValue} from 'motion/react';
import {ANIMATION_CONFIG} from './animation-config';

export const useChipsScroll = (mainScrollProgress: MotionValue<number>) => {
    const chipsX = useTransform(mainScrollProgress, [0, 1], [0, -6500]);
    const smoothChipsX = useSpring(chipsX, ANIMATION_CONFIG.CHIPS.X);

    const containerScale = useTransform(mainScrollProgress, [0, 0.3, 0.7, 1], [1, 1.02, 1.02, 1]);
    const smoothScale = useSpring(containerScale, ANIMATION_CONFIG.CHIPS.SCALE);

    return {
        chipsX: smoothChipsX,
        containerScale: smoothScale,
    };
};
